/**
 * @ngdoc directive
 * @name prohealth.directive:Header Notification
 * @description
 * # PosHeader
 */
(function () {
  'use strict';
  angular.module('myApp')
    .directive('headerNotification', HeaderNotification);

  function HeaderNotification() {
    var directiveObj = {};
    directiveObj.bindToController = {
      notificationcount: '=',
      changepasswordpopup: '&',
      changepassword: '&',
      currentpassword: '='
    }
    directiveObj.controller = HeaderController;
    directiveObj.controllerAs = 'vm';
    directiveObj.templateUrl = 'js/scripts/directives/header/header-notification/header-notification.html',
      directiveObj.restrict = 'E';
    directiveObj.replace = true;
    return directiveObj;
  }

  function HeaderController($scope, authApi, ngDialog, shareProfile) {
    var vm = this;
    /*  vm.changePasswordClick = vm.changePasswordPopup;
      vm.changePassword = vm.changePassword;*/
    vm.logout = authApi.logout;
    vm.shareProfile = shareProfile.share;
  }

  function LogoutPrompt() {
    // dialogId = ngDialog.open({
    //   template: 'prnJobInfoPopup',
    //   className: 'ngdialog-theme-default documentation-dialog prn-dialog incompleteDashboard',
    //   closeByNavigation: true,
    //   showClose: false,
    //   scope: $scope,
    //   closeByDocument: false,
    //   closeByEscape: false
    // });
  }

})();
